import { Select, Stack, createListCollection } from '@chakra-ui/react';
import LLDSearch from '../search/lld-search';
import LatLongSearch from '../search/lat-long-search';
import UTMSearch from '../search/utm-search';
import RMSearch from '../search/rm-search';
import HereSearch from '../search/here-search';
import PolygonIDSearch from '../search/polygon-id-search';
import CitySearch from '../search/city-search';
import { useState, useEffect } from 'react';
import { storageManager } from '@/lib/utils/storage-manager';

const searchTypes = createListCollection({
  items: [
    { label: 'Legal Land Description', value: 'lld' },
    { label: 'Lat Long (DD)', value: 'latlong' },
    { label: 'UTM', value: 'utm' },
    { label: 'RM', value: 'rm' },
    { label: 'Here', value: 'here' },
    { label: 'Polygon ID', value: 'polygon' },
    { label: 'Search place name', value: 'city' },
  ],
});

export default function Search({ onClose }: { onClose: () => void }) {
  const [selectedType, setSelectedType] = useState(() => storageManager.loadSearchType() || '');

  useEffect(() => {
    storageManager.saveSearchType(selectedType);
  }, [selectedType]);

  const renderSearchComponent = () => {
    switch (selectedType) {
      case 'lld':
        return <LLDSearch onClose={onClose} />;
      case 'latlong':
        return <LatLongSearch onClose={onClose} />;
      case 'utm':
        return <UTMSearch onClose={onClose} />;
      case 'rm':
        return <RMSearch onClose={onClose} />;
      case 'here':
        return <HereSearch onClose={onClose} />;
      case 'polygon':
        return <PolygonIDSearch onClose={onClose} />;
      case 'city':
        return <CitySearch onClose={onClose} />;
      default:
        return <LLDSearch onClose={onClose} />;
    }
  };

  return (
    <Stack gap='4'>
      <Select.Root
        collection={searchTypes}
        value={[selectedType]}
        onValueChange={(e) => setSelectedType(e.value[0])}
      >
        <Select.HiddenSelect />
        <Select.Label>Search Type</Select.Label>
        <Select.Control>
          <Select.Trigger>
            <Select.ValueText placeholder="Select search type" />
          </Select.Trigger>
          <Select.IndicatorGroup>
            <Select.Indicator />
          </Select.IndicatorGroup>
        </Select.Control>
        <Select.Content>
          {searchTypes.items.map((item) => (
            <Select.Item key={item.value} item={item}>
              {item.label}
            </Select.Item>
          ))}
        </Select.Content>
      </Select.Root>

      {renderSearchComponent()}
    </Stack>
  );
}
